import { render, staticRenderFns } from "./add-product-modal.vue?vue&type=template&id=28264698&scoped=true&"
import script from "./add-product-modal.vue?vue&type=script&lang=js&"
export * from "./add-product-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-product-modal.vue?vue&type=style&index=0&id=28264698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28264698",
  null
  
)

export default component.exports